<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
      class="ma-2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="dataSettlement"
      :options.sync="options"
      :server-items-length="totalDataSettlement"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="trx_datetime"
      :sort-desc="true"
      :style="{ padding: '10px', height: '70vh' }"
      fixed-header
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />

          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.rrn"
              label="Reff ID"
              type="text"
              @change="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Merchant Name"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid_bank"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mpan"
              type="text"
              label="MPAN"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>

          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-autocomplete
              clearable
              v-model="search.issuer_name"
              :items="itemsIssuer"
              item-text="issuer_name"
              item-value="issuer_name"
              label="Issuer Name"
              :loading="loadingIssuer"
              :search-input.sync="searchIssuer"
              @change="getData"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.customer_pan"
              label="Customer PAN"
              type="text"
              @change="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.payment_type"
              :items="listPaymentType"
              label="Payment Type"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>

          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <template>
            <v-dialog
              ref="rangeDateDialog"
              v-model="rangeDateDialog"
              :return-value.sync="filter.trx_datetime"
              persistent
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="rangeDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Transaction Date"
                  hide-details="true"
                >
                  <template v-slot:append-outer>
                    <v-btn large text color="orange" @click="showData">
                      <v-icon left> mdi-magnify </v-icon>search
                    </v-btn>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="filter.trx_datetime"
                scrollable
                range
                :min="minDate"
                :max="maxDate"
              >
                <v-spacer />
                <v-btn text color="primary" @click="rangeDateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    () => {
                      checkRangeDate();
                      $refs.rangeDateDialog.save(filter.trx_datetime);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </template>

          <v-spacer />
          <template>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :style="{ 'margin-right': '10px' }"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportItem()">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.rrn }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid_bank }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mpan }}
          </td>

          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.issuer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_pan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.amount }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_datetime }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.recon_status_data }}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="clearSearch"
          :disabled="loading"
          :loading="loading"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import {
  dataListPaymentType,
  dataMinRangeDate,
  dataMaxRangeDate,
} from '../../store/params';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    view: false,
    show: false,
    dialog: false,
    expanded: [],
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'trx_id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Reff ID',
        value: 'rrn',
        width: '150',
        align: 'center',
      },
      {
        text: 'Merchant Name',
        value: 'merchant_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'MID',
        value: 'mid_bank',
        width: '150',
        align: 'center',
      },
      {
        text: 'Merchant PAN',
        value: 'mpan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Issuer Name',
        value: 'issuer_name',
        width: '100',
        align: 'center',
      },
      {
        text: 'Customer PAN',
        value: 'customer_pan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Payment Type',
        value: 'payment_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Amount',
        value: 'amount',
        width: '150',
        align: 'center',
      },
      {
        text: 'Transaction Date',
        value: 'trx_datetime',
        width: '150',
        align: 'center',
      },
      {
        text: 'Reconciliation Status',
        value: 'recon_status',
        width: '100',
        align: 'center',
      },
    ],
    editedIndex: -1,
    filter: {
      trx_datetime: [],
    },
    search: {
      merchant_name: '',
      mid_bank: '',
      mpan: '',
      rrn: '',
      issuer_name: '',
      customer_pan: '',
      payment_type: '',
      trx_datetime: [],
    },
    selectedRow: '',
    selectedData: [],
    selectAllData: false,
    listPaymentType: dataListPaymentType,
    searchAcquirer: '',
    searchIssuer: '',
    dateMenu: false,
    dateMenuResettlement: false,
  }),

  computed: {
    flashError: {
      get() {
        return this.$store.state.reconciliation.transactionReconciliation
          .flashError;
      },
      set() {
        this.$store.commit('reconciliation/transactionReconciliation', '');
      },
    },

    dateRangeText() {
      return this.filter.trx_datetime.join(' ~ ');
    },

    ...mapState('reconciliation/transactionReconciliation', {
      loading: (state) => state.isLoading,
      flashErrorMessage: 'flashErrorMessage',
      dataSettlement: 'allSettlement',
      totalDataSettlement: 'totalSettlement',
    }),

    totalPage() {
      return this.$store.state.reconciliation.transactionReconciliation
        .totalPage;
    },

    itemsAcquirer() {
      return this.$store.state.report.merchantTransaction.allAcquirer;
    },

    itemsIssuer() {
      return this.$store.state.report.merchantTransaction.allIssuer;
    },

    loadingAcquirer() {
      return this.$store.state.report.merchantTransaction.loadingAcquirer;
    },
    loadingIssuer() {
      return this.$store.state.report.merchantTransaction.loadingIssuer;
    },

    minDate() {
      if (this.filter.trx_datetime.length > 0) {
        const tempMinDate = Date.parse(this.filter.trx_datetime[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }

      return '';
    },
    maxDate() {
      if (this.filter.trx_datetime.length > 0) {
        const tempMaxDate = Date.parse(this.filter.trx_datetime[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }

      return this.today;
    },
  },

  async mounted() {
    this.getAcquirer();
    this.getIssuer();
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit(
            'reconciliation/transactionReconciliation/clearSettlement'
          );
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid_bank = '';
      this.search.mpan = '';
      this.search.rrn = '';
      this.search.issuer_name = '';
      this.search.customer_pan = '';
      this.search.payment_type = '';
      this.search.trx_datetime = [];
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    checkRangeDate() {
      if (this.search.trx_datetime.length == 1) {
        this.search.trx_datetime.push(this.search.trx_datetime[0]);
      }
    },

    getAcquirer() {
      this.$store.dispatch('report/merchantTransaction/getAcquirer', {
        date,
      });
    },

    getIssuer() {
      this.$store.dispatch('report/merchantTransaction/getIssuer', {
        date,
      });
    },

    showData() {
      this.search.trx_datetime = this.filter.trx_datetime;
      this.getData();
    },

    getData() {
      if (this.filter.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit(
          'reconciliation/transactionReconciliation/clearSettlement'
        );
      } else {
        this.$store.commit(
          'reconciliation/transactionReconciliation/setFlashErrorMessage',
          ''
        );
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        this.$store
          .dispatch('reconciliation/transactionReconciliation/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    sortDate(varDate) {
      const [date1, date2] = this.search[varDate].map(Date.parse);

      if (date1 > date2) {
        [this.search[varDate][0], this.search[varDate][1]] = [date2, date1];
      }
    },

    closeFlash() {
      this.$store.commit(
        'reconciliation/transactionReconciliation/setFlashErrorMessage',
        ''
      );
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    getDate,
    exportItem() {
      if (this.filter.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit(
          'reconciliation/transactionReconciliation/clearSettlement'
        );
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch(
          'reconciliation/transactionReconciliation/exportList',
          {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          }
        );
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
